import i18next from "i18next";

export enum AgencyFormSectionEnum {
    INFORMATION = 1,
    AUTHORIZATION_TOKEN,
    BILLING,
    AVAILABLE_MARKETS,
    PHYSICAL_MAIL_TYPES,
    TWILIO_CONFIG,
    DOCUSIGN_CONFIG,
    DOCUSIGN_TEMPLATES
}

export const AgencyFormSectionLabel = (key: string) => ({ 
    [AgencyFormSectionEnum.INFORMATION]: i18next.t('INFORMATION'),
    [AgencyFormSectionEnum.AUTHORIZATION_TOKEN]: i18next.t('AUTHORIZATION_TOKEN'),
    [AgencyFormSectionEnum.BILLING]: i18next.t('BILLING'),
    [AgencyFormSectionEnum.AVAILABLE_MARKETS]: i18next.t('AVAILABLE_MARKETS'),
    [AgencyFormSectionEnum.PHYSICAL_MAIL_TYPES]: i18next.t('PHYSICAL_MAIL_TYPES'),
    [AgencyFormSectionEnum.TWILIO_CONFIG]: i18next.t('TWILIO_CONFIG'),
    [AgencyFormSectionEnum.DOCUSIGN_CONFIG]: i18next.t('DOCUSIGN_CONFIG'),
    [AgencyFormSectionEnum.DOCUSIGN_TEMPLATES]: i18next.t('DOCUSIGN_TEMPLATES')
})[key];

export interface AgencyFormSection {
    key:number,
    value:string
    label:string
}

export const getAgencyFormSections = () =>
    Object.values(AgencyFormSectionEnum).filter(x => !isNaN(Number(x))).map(element => {
        const value = `${element}`
        return  {
            key: element,
            value: value,
            label: AgencyFormSectionLabel(value) ?? ""
        } as AgencyFormSection
    });